import { VideoAudioConfig } from '../utils/video-and-audio-config';

angular.module('app.filters').filter('configLabel', ($rootScope) => {
  'ngInject';
  const { ApiConfig } = $rootScope;
  return (value, section, subsection, defaultValue = null) => {
    const cfg =
      (ApiConfig[section] || {})[subsection] || (VideoAudioConfig[section] || {})[subsection];
    const result = _.find(cfg, (item) => item.value == value);
    return _.get(result, 'label', defaultValue);
  };
});



// WEBPACK FOOTER //
// ./app/filters/config-label.js